var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_9824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 1.33331H5.99994C5.63179 1.33331 5.33334 1.63176 5.33334 1.99991V3.3331C5.33334 3.70125 5.63179 3.9997 5.99994 3.9997H9.99951C10.3677 3.9997 10.6661 3.70125 10.6661 3.3331V1.99991C10.6661 1.63176 10.3677 1.33331 9.99951 1.33331Z",
    stroke: "#FC6A18",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66669H12C12.3536 2.66669 12.6928 2.80716 12.9428 3.05721C13.1928 3.30726 13.3333 3.6464 13.3333 4.00002V13.3334C13.3333 13.687 13.1928 14.0261 12.9428 14.2762C12.6928 14.5262 12.3536 14.6667 12 14.6667H3.99999C3.64637 14.6667 3.30723 14.5262 3.05718 14.2762C2.80713 14.0261 2.66666 13.687 2.66666 13.3334V4.00002C2.66666 3.6464 2.80713 3.30726 3.05718 3.05721C3.30723 2.80716 3.64637 2.66669 3.99999 2.66669H5.33332",
    stroke: "#FC6A18",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.33319L7.33319 10.6664L9.99957 8",
    stroke: "#FC6A18",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_9824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.ef7b45c9.svg";
export { ForwardRef as ReactComponent };